import { render, staticRenderFns } from "./Renewe.vue?vue&type=template&id=2b5537e6&"
import script from "./Renewe.vue?vue&type=script&lang=js&"
export * from "./Renewe.vue?vue&type=script&lang=js&"
import style0 from "./Renewe.vue?vue&type=style&index=0&id=2b5537e6&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports